import { Typography, LazyImage, Badge } from '@frontend/design_system'
import warningIcon from 'assets/icons/yellow700/yellow700_warning_20x20.webp'
import styles from './styles.module.scss'
import { joinClasses } from 'utils/joinClasses'
import { MissingFieldsBadgeProps } from './types'

export const MissingFieldsBadge = ({
  message,
  offsetVariant = 'primary',
}: MissingFieldsBadgeProps) => (
  <Badge
    className={joinClasses(styles.badge, styles[`offset-${offsetVariant}`])}
    message={
      <Typography
        name="body1WMedium"
        color="yellow800"
        className={styles['badge-message']}
      >
        {message} <LazyImage src={warningIcon} minWidth={20} height={20} />
      </Typography>
    }
    type="warning"
  />
)
